<template>
	<BButton
		variant="success"
		type="submit"
		class="checkout-button__button"
		:disabled="modifyingOrSubmittingOrder"
		data-vs-tracking="pay-now-button"
		@click="submitOrder"
	>
		<span v-if="!submittingOrder"> Pay Now </span>
		<BSpinner v-else small label="processing order"></BSpinner>
	</BButton>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
	computed: {
		...mapState('checkout', ['submittingOrder']),
		...mapGetters('checkout', ['modifyingOrSubmittingOrder']),
	},

	methods: mapActions('checkout', ['submitOrder']),
};
</script>
